export enum ContractType {
    Permanent = 'permanent',
    Contract = 'contract',
}
